import { useMemo } from "react";
import { type TenantSettings, useTenantSettings } from "./useTenantSettings";

/**
 * A KPI's display label: the tenant's `kpi_label` row for `kpi` (a catalogue
 * id such as `GS2`), else `productLabel`.
 */
export type KpiLabel = (kpi: string, productLabel: string) => string;

/** The label lookup over one tenant's settings read. */
function kpiLabelResolver(settings: TenantSettings | undefined): KpiLabel {
  const labels = Object.fromEntries(
    (settings?.settings.kpi_label.rows ?? []).map((row) => [
      row.key.kpi,
      row.value
    ])
  );
  return function kpiLabel(kpi: string, productLabel: string) {
    return labels[kpi] ?? productLabel;
  };
}

/**
 * The active tenant's KPI label lookup: its `kpi_label` rows over the caller's
 * product label. Product labels show while the settings load.
 */
export function useKpiLabel(): KpiLabel {
  const { data } = useTenantSettings();
  return useMemo(() => kpiLabelResolver(data), [data]);
}
